// B1-INT Level Aggregator - B1 Interview Training
// Tüm B1-INT ünite içeriklerini birleştirir

import { B1INT_UNIT_1 } from './kariyerContentsB1INTUnit1';
import { B1INT_UNIT_2 } from './kariyerContentsB1INTUnit2';
import { B1INT_UNIT_3 } from './kariyerContentsB1INTUnit3';

export const B1INT_LEVEL = {
  ...B1INT_UNIT_1,  // Temel Mülakat Soruları
  ...B1INT_UNIT_2,  // Deneyim ve Motivasyon Soruları
  ...B1INT_UNIT_3,  // Mini Mülakat Simülasyonu
};

export default B1INT_LEVEL;
